import React from 'react';
import { graphql } from 'gatsby';
import Header from '@components/Header';
import Page from '@components/Page';
import Footer from '@components/Footer';
import BlogPosts from '@components/BlogPosts';
import FeaturedPost from '@components/FeaturedPost';

export default function BlogTemplate(data) {
  const {
    data: {
      page,
      posts,
      featured,
      authors
    },
    pageContext: { language, refs, layouts }
  } = data;
  return (
    <Page>
      <FeaturedPost
        featured={featured}
        author={authors.nodes.find(({ wordpress_id }) => wordpress_id === featured.acf.author)}
        language={language}
        divider={{ variant: 1, backgroundClass: 'bg-primary' }}
        parent={page}
        link
      >
        <Header
          language={language}
          refs={refs}
          layouts={layouts}
        />
      </FeaturedPost>
      <BlogPosts
        parent={page}
        posts={posts}
        authors={authors}
        language={language}
      />
      <Footer
        language={language}
        layouts={layouts}
      />
    </Page>
  );
}

export const query = graphql`
  query($id: Int, $blogPostId: Int, $lang: String) {
    page: wordpressWpWebsites(wordpress_id: { eq: $id }) {
      ...Page
    }
    posts: allWordpressWpBlogposts(filter: {lang: {eq: $lang}, wordpress_id: {ne: $blogPostId}}) {
      nodes {
        ...BlogPosts
      }
    }
    featured: wordpressWpBlogposts(wordpress_id: {eq: $blogPostId}) {
      ...FeaturedPost
    }
    authors: allWordpressWpTeammembers(filter: {lang: {eq: $lang}}) {
      nodes {
        wordpress_id
        acf {
          name
          photo {
            localFile {
              sharp: childImageSharp {
                fluid(maxWidth: 40, maxHeight: 40) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
        }
      }
    }
  }
`;